export default "__VITE_ASSET__BmVuLCpD__"